import { createInjectionKey as e } from "../../_utils/vue/create-injection-key.js";
const c = e("n-date-picker");
export {
  c as datePickerInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/date-picker/src/interface.js
// module id = 327
// module chunks = 67